import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from '../modal';
import { Button } from '../button';
import { Flex } from '../grid';
import { P, Subheading } from '../typography';

const CartClearModal = ({ open, onReturnToOriginal, onContinueToSecondary, returnButtonText, continueButtonText }) => {
  return (
    <Modal
      open={open}
      handleClose={onReturnToOriginal}
      modalTitle=""
      hasFooterDivider={false}
      webHeight="auto"
      width={{ _: '90%', md: '552px' }}
      height="auto"
      borderRadius="24px"
      isDividerHidden
    >
      <Flex width="100%" justifyContent="center">
        <Flex
          textAlign="center"
          flexDirection="column"
          gap={{ xs: '24px', md: '32px' }}
          mx="40px"
          maxWidth={{ xs: '271px', lg: '360px' }}
          py="16px"
          pt="0"
        >
          <Flex flexDirection="column" alignItems="center" gap="8px">
            <Subheading mb={0} fontWeight="600" color="black" variant={2}>
              Switching order types
            </Subheading>

            <P variant={2}>To switch order types, we need to start fresh. Want to go ahead?</P>
          </Flex>

          <Flex justifyContent="center" width="100%">
            <Flex
              flexDirection={{ _: 'column' }}
              gap={{ xs: '8px', md: '16px' }}
              justifyContent="center"
              alignItems="center"
              width="fit-content"
            >
              <Button variant="primary" size="small" onClick={onReturnToOriginal} width="100%">
                {returnButtonText}
              </Button>
              <Button
                variant="actionSecondary"
                onClick={onContinueToSecondary}
                style={{ background: 'transparent' }}
                width="100%"
              >
                {continueButtonText}
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
};

CartClearModal.propTypes = {
  open: PropTypes.bool,
  onReturnToOriginal: PropTypes.func,
  onContinueToSecondary: PropTypes.func,
  continueButtonText: PropTypes.string,
  returnButtonText: PropTypes.string,
};

CartClearModal.defaultProps = {
  open: false,
  onReturnToOriginal: () => {},
  onContinueToSecondary: () => {},
  continueButtonText: 'CONTINUE',
  returnButtonText: 'RETURN',
};

export { CartClearModal };
